<template>
  <div class="qa-priority">
    <app-segmented-control
      :active-option="modelValue"
      :options="priorityOptions"
      :disabled="disabled"
      class="qa-priority__segmented"
      data-locator="qa-priority-segmented-control"
      @change-active-option="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script>
import { QA_PRIORITIES, getQAPriorityMeta } from '@/project/question-answer/constants/qaPriority'

export default {
  name: 'QuestionAnswerPrioritySelect',
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    priorityOptions () {
      return QA_PRIORITIES.map((priority) => {
        const meta = getQAPriorityMeta(priority, this.$t)

        return {
          name: meta.label,
          value: priority,
          locatorValue: meta.locatorValue,
          icon: meta.icon,
          iconColor: meta.iconColor,
        }
      })
    },
  },
  emits: ['update:modelValue'],
}
</script>

<style scoped lang="scss">
.qa-priority {
  &__segmented {
    width: 100%;
  }

  &__errors {
    margin-top: 8px;
  }
}
</style>
